module.exports = __webpack_public_path__ + "static/media/9.04ddf595.jpg";